import React from "react";
import { Menu, type MenuItemProps } from "@design-system/Menu/Menu.lib";
import { useSettings } from "../../settings/SettingsProvider";

interface SettingsDropdownItemProps extends Omit<MenuItemProps, "onClick"> {
    path: string;
}

export const SettingsDropdownItem: React.FC<SettingsDropdownItemProps> = ({
    path,
    children,
    ...props
}) => {
    const { validPaths, open } = useSettings();
    if (!validPaths.includes(path)) {
        return null;
    }
    return (
        <Menu.Item {...props} onClick={() => open([path])}>
            {children}
        </Menu.Item>
    );
};
